(() => {
 const instances = new Map();
 function initConveyor(root) {
  if (instances.has(root)) return;
  const controller = new AbortController();
  const signal = controller.signal;
  const cleanups = [];
  const listen = (target,event,callback,options={}) => target.addEventListener(event,callback,{...options,signal});

  // Load below-fold decoration shortly before it enters view, not during hero loading.
  const artworkGroups = [...root.querySelectorAll('.weigh-shop__scene, .scale-stickers, .ready-mixes, .party-scene, .sweet-marquee, .sweet-faq')];
  function revealArtwork(group) {
    group.classList.add('art-ready');
    group.querySelectorAll('[data-scene-srcset]').forEach(node=>{
      node.setAttribute('srcset',node.dataset.sceneSrcset);delete node.dataset.sceneSrcset;
    });
    group.querySelectorAll('img[data-scene-src]').forEach(image=>{
      image.loading='eager';image.src=image.dataset.sceneSrc;delete image.dataset.sceneSrc;
    });
    group.querySelectorAll('img[data-art-src]').forEach(image => {
      image.src = image.dataset.artSrc;
      image.removeAttribute('data-art-src');
    });
    group.querySelectorAll('image[data-art-href]').forEach(image => {
      const source = image.getAttribute('data-art-href');
      image.setAttribute('href', source);
      image.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', source);
      image.removeAttribute('data-art-href');
    });
  }
  if ('IntersectionObserver' in window) {
    const artworkObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        revealArtwork(entry.target);
        artworkObserver.unobserve(entry.target);
      });
    }, {rootMargin: '100px 0px'});
    const heroArtwork = root.querySelector('.filled-conveyor img');
    let observingArtwork=false;
    const observeArtwork = () => {
      if(observingArtwork)return;observingArtwork=true;
      artworkGroups.forEach(group=>artworkObserver.observe(group));
    };
    // Fast scrollers should not wait for an image that is already off screen.
    listen(window,'scroll',observeArtwork,{once:true,passive:true});
    if (!heroArtwork || heroArtwork.complete || window.scrollY > 0 || window.location.hash) observeArtwork();
    else {
      listen(heroArtwork, 'load', observeArtwork, {once:true});
      listen(heroArtwork, 'error', observeArtwork, {once:true});
    }
    cleanups.push(() => artworkObserver.disconnect());
  } else artworkGroups.forEach(revealArtwork);


  const cardImages = [...root.querySelectorAll('img[data-card-src]')];
  function revealCard(image) {
    if (image.dataset.cardSrcset) {
      image.srcset = image.dataset.cardSrcset;
      delete image.dataset.cardSrcset;
    }
    image.loading = 'eager';
    image.src = image.dataset.cardSrc;
    delete image.dataset.cardSrc;
  }
  const heroImage = root.querySelector('.filled-conveyor img');
  let startedSecondaryImages = false;
  function startSecondaryImages() {
    if (startedSecondaryImages) return;
    startedSecondaryImages = true;
    root.querySelectorAll('img[data-hero-src]').forEach(image => {
      image.src = image.dataset.heroSrc;
      delete image.dataset.heroSrc;
    });
    if ('IntersectionObserver' in window) {
      const cardsObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          revealCard(entry.target);
          cardsObserver.unobserve(entry.target);
        });
      }, {rootMargin: '700px 0px'});
      cardImages.forEach(image => cardsObserver.observe(image));
      cleanups.push(() => cardsObserver.disconnect());
    } else cardImages.forEach(revealCard);
  }
  if (!heroImage || heroImage.complete || window.scrollY > 0 || window.location.hash) startSecondaryImages();
  else {
    listen(heroImage, 'load', startSecondaryImages, {once:true});
    listen(heroImage, 'error', startSecondaryImages, {once:true});
    listen(window, 'scroll', startSecondaryImages, {once:true,passive:true});
  }

  // Keep the lower belt's paper aligned when product filters change section height.
  const readyPaper = document.querySelector('.ready-mixes');
  const readyPaperEnd = document.querySelector('.sweet-marquee--party');
  if (readyPaper && readyPaperEnd) {
    const alignReadyPaper = () => readyPaperEnd.style.setProperty('--ready-paper-height', `${readyPaper.getBoundingClientRect().height}px`);
    alignReadyPaper();
    if ('ResizeObserver' in window) new ResizeObserver(alignReadyPaper).observe(readyPaper);
    else listen(window, 'resize', alignReadyPaper, {passive:true});
  }

  const body = document.body;
  const header = root.querySelector('.site-header');
  const menu = root.querySelector('.mobile-menu');
  const toggle = root.querySelector('.menu-toggle');
  const dialog = root.querySelector('.size-dialog');
  const continueLink = root.querySelector('.dialog-continue');
  let opener;

  const menuBackground = new Map();
  function setMenu(open, restoreFocus = false) {
    menu.hidden = !open;
    body.classList.toggle('se-menu-open', open);
    if (open) {
      document.querySelectorAll('main, .sweet-footer, .rm-dock, .sb-mobile-dock, .se-cart-checkout-dock').forEach(node => {
        if (!menuBackground.has(node)) menuBackground.set(node, node.inert);
        node.inert = true;
      });
    } else {
      menuBackground.forEach((previous, node) => { node.inert = previous; });
      menuBackground.clear();
    }
    toggle.setAttribute('aria-expanded', String(open));
    toggle.setAttribute('aria-label', open ? toggle.dataset.closeLabel : toggle.dataset.openLabel);
    if (restoreFocus) toggle.focus({ preventScroll: true });
    syncMotion();
  }
  listen(toggle,'click', () => setMenu(menu.hidden));
  menu.querySelectorAll('a[href]').forEach(link => listen(link,'click', () => setMenu(false)));
  listen(document,'click', event => {
    if (!menu.hidden && !header.contains(event.target)) setMenu(false);
  });
  listen(document,'keydown', event => {
    if (event.key === 'Escape' && !menu.hidden) setMenu(false, true);
    if (event.key === 'Tab' && !menu.hidden) {
      const items = [toggle, ...menu.querySelectorAll('a[href]')];
      const first = items[0], last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    }
  });
  listen(matchMedia('(min-width: 960px)'),'change', event => {
    if (event.matches) setMenu(false);
  });

  function updateSize() {
    const selected = dialog.querySelector('input:checked');
    if (!selected) return;
    continueLink.href = selected.dataset.url;
    continueLink.querySelector('span').textContent = `${continueLink.dataset.label} — ${selected.dataset.priceFormatted}`;
  }
  root.querySelectorAll('[data-build]').forEach(link => {
    listen(link,'click', event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      if (!dialog.querySelector('input:not(:disabled)')) return;
      event.preventDefault();
      opener = link;
      setMenu(false);
      if (link.dataset.size) { const input = dialog.querySelector(`input[value="${link.dataset.size}"]`); if (input && !input.disabled) input.checked = true; }
      updateSize();
      dialog.showModal();
      body.classList.add('dialog-open');
      syncMotion();
    });
  });
  dialog.querySelectorAll('input').forEach(input => listen(input,'change', updateSize));
  listen(dialog.querySelector('.dialog-close'),'click', () => dialog.close());
  listen(dialog,'click', event => {
    const bounds = dialog.getBoundingClientRect();
    if (event.target === dialog && (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom)) dialog.close();
  });
  listen(dialog,'close', () => {
    body.classList.remove('dialog-open');
    syncMotion();
    if (opener?.closest('.mobile-menu')) toggle.focus({ preventScroll: true });
    else opener?.focus({ preventScroll: true });
  });

  const mixFilters = root.querySelector('.mix-filters');
  if (mixFilters) {
    const mixCards = [...root.querySelectorAll('.mix-card[data-mix-category]')];
    const filterButtons = [...mixFilters.querySelectorAll('[data-mix-filter]')];
    const mixResults = root.querySelector('.mix-results');
    mixFilters.hidden = false;
    filterButtons.forEach(button => listen(button, 'click', () => {
      const category = button.dataset.mixFilter;
      filterButtons.forEach(filter => filter.setAttribute('aria-pressed', String(filter === button)));
      let visible = 0;
      mixCards.forEach(card => {
        card.hidden = category !== 'all' && card.dataset.mixCategory !== category;
        if (!card.hidden) visible++;
      });
      mixResults.textContent = (visible === 1 ? mixResults.dataset.one : mixResults.dataset.many).replace('[count]', visible).replace('[category]', button.textContent.trim());
    }));
  }

  const weighingShop = root.querySelector('.weigh-shop');
  if (weighingShop) {
    const scale = weighingShop.querySelector('.sweet-scale');
    const ticks = scale.querySelector('.sweet-scale__ticks');
    const scaleLink = weighingShop.querySelector('.weigh-shop__cta');
    const selection = weighingShop.querySelector('.weigh-shop__selection strong');
    const arrangements = [...scale.querySelectorAll('.sweet-scale__arrangement')];
    let selectionRevision = 0;
    ticks.replaceChildren();

    for (let step = 0; step <= 40; step++) {
      const radians = (-135 + step * 6.75) * Math.PI / 180;
      const major = step % 10 === 0;
      const tick = document.createElementNS('http://www.w3.org/2000/svg', 'line');
      const inner = major ? 207 : 220;
      tick.setAttribute('x1', String(270 + Math.sin(radians) * inner));
      tick.setAttribute('y1', String(265 - Math.cos(radians) * inner));
      tick.setAttribute('x2', String(270 + Math.sin(radians) * 236));
      tick.setAttribute('y2', String(265 - Math.cos(radians) * 236));
      if (major) tick.classList.add('major-tick');
      ticks.append(tick);
    }
    async function updateScale() {
      const selected = weighingShop.querySelector('input[name="scale-weight"]:checked');
      if (!selected) return;
      const revision = ++selectionRevision;
      weighingShop.dataset.weight = selected.value;
      selection.textContent = `${selected.value} ${selected.dataset.pack} — ${selected.dataset.priceFormatted}`;
      scaleLink.href = selected.dataset.url;
      scaleLink.setAttribute('aria-label', `${weighingShop.dataset.ctaLabel} — ${selected.value}, ${selected.dataset.priceFormatted}`);
      const next = arrangements.find(picture => picture.dataset.pile === selected.dataset.pile);
      if (!next) return;
      const photo = next.querySelector('img');
      if (!next.classList.contains('is-active')) {

        photo.loading = 'eager';
        next.querySelectorAll('[data-srcset]').forEach(node => {
          node.setAttribute('srcset', node.dataset.srcset);
          delete node.dataset.srcset;
        });
        if (photo.dataset.src) {
          photo.src = photo.dataset.src;
          delete photo.dataset.src;
        }
        try {
          await photo.decode();
        } catch {

          return;
        }
      }
      if (signal.aborted || revision !== selectionRevision) return;
      const previousPile = scale.dataset.visiblePile;
      arrangements.forEach(picture => picture.classList.toggle('is-active', picture === next));
      scale.style.setProperty('--needle-angle', `${selected.dataset.angle}deg`);
      scale.dataset.visiblePile = selected.dataset.pile;
      if (previousPile && previousPile !== selected.dataset.pile) {
        weighingShop.dispatchEvent(new CustomEvent('mix:changed'));
      }
    }
    listen(weighingShop.querySelector('.sweet-weights'),'change', updateScale);
    updateScale();
  }

  const hero = root.querySelector('.hero');
  const clouds = [...root.querySelectorAll('.floss-cloud')];
  const marquees = [...root.querySelectorAll('.sweet-marquee')];
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const stickerScene = root.querySelector('.scale-stickers');
  if (stickerScene && 'IntersectionObserver' in window) {
    const compactStickers = matchMedia('(max-width: 959px)');
    const phoneStickers = matchMedia('(max-width: 759px)');
    const stickers = [...stickerScene.querySelectorAll('.scale-sticker')].map((node, index) => ({
      node, index, art:node.querySelector('.scale-sticker__art'),
      motion:node.querySelector('.scale-sticker__motion'), animation:null
    }));
    const accents = [stickers[0], stickers[1], stickers[6]];


    let inView = false, frame = 0, turn = 0, targetTurn = 0;
    let lastY = window.scrollY, lastScroll = 0, lastFrame = 0;
    const canMove = () => !signal.aborted && inView && !document.hidden && !reducedMotion.matches;
    const visibleStickers = () => stickers.filter(({index}) => !compactStickers.matches || (index !== 3 && index !== 7));
    function stopStickerScroll() {
      cancelAnimationFrame(frame);
      frame = 0;
      turn = targetTurn = lastFrame = 0;
      lastY = window.scrollY;
      accents.forEach(({motion}) => motion.style.removeProperty('transform'));
    }
    function stopStickerMotion() {
      stopStickerScroll();
      stickers.forEach(sticker => {
        sticker.animation?.cancel();
        sticker.animation = null;
      });
    }
    function syncStickers() {
      const active = canMove();
      stickerScene.classList.toggle('is-active', active);
      if (reducedMotion.matches) {
        stickerScene.classList.remove('stickers-motion');
        stickerScene.classList.add('is-visible');
      } else {
        stickerScene.classList.add('stickers-motion');
        if (active) stickerScene.classList.add('is-visible');
      }
      if (!active) stopStickerMotion();
    }
    function settleStickers(now) {
      frame = 0;
      if (!canMove()) return stopStickerMotion();
      const elapsed = Math.min(40, now - (lastFrame || now - 16));
      lastFrame = now;
      if (now - lastScroll > 120) targetTurn = 0;
      turn += (targetTurn - turn) * (1 - Math.exp(-elapsed / 65));
      if (targetTurn === 0 && Math.abs(turn) < .015) return stopStickerScroll();
      accents.forEach(({motion}, index) => {
        const direction = index === 1 ? -1 : 1;

        const lift = index === 1 ? -Math.abs(turn) * 1.5 : turn * 1.25;
        motion.style.transform = `translateY(${lift.toFixed(3)}px) rotate(${(turn * direction).toFixed(3)}deg)`;
      });
      frame = requestAnimationFrame(settleStickers);
    }
    listen(window, 'scroll', () => {
      const y = window.scrollY;
      const delta = y - lastY;
      lastY = y;
      if (!canMove() || Math.abs(delta) < .1) return;
      lastScroll = performance.now();
      const limit = phoneStickers.matches ? 9 : 13;
      targetTurn = Math.max(-limit, Math.min(limit, delta * 1.2));
      if (!frame) frame = requestAnimationFrame(settleStickers);
    }, {passive:true});
    listen(weighingShop,'mix:changed', () => {
      if (!canMove() || !Element.prototype.animate) return;
      const small = phoneStickers.matches;
      const vectors = small
        ? [[-4,-11],[2,-13],[4,-8],[0,0],[-5,-9],[4,-7],[-4,-10],[0,0]]
        : [[-8,-19],[0,-23],[6,-17],[8,-15],[-10,-15],[10,-12],[-8,-18],[8,-14]];
      visibleStickers().forEach((sticker, order) => {

        const start = getComputedStyle(sticker.art).transform;
        sticker.art.getAnimations().forEach(animation => animation.cancel());
        const [x,y] = vectors[sticker.index];
        const twist = (sticker.index % 2 ? 1 : -1) * (small ? 10 : 15);
        const animation = sticker.art.animate([
          {transform:start === 'none' ? 'translate(0,0) rotate(0deg)' : start},
          {transform:`translate(${x}px,${y}px) rotate(${twist}deg) scale(1.06)`,offset:.32},
          {transform:`translate(0,${sticker.index === 1 ? -1 : 2}px) rotate(${-twist * .16}deg) scale(.99)`,offset:.73},
          {transform:'translate(0,0) rotate(0deg)'}
        ], {duration:small ? 380 : 390,delay:order * 30,easing:'cubic-bezier(.22,.7,.3,1)',fill:'backwards'});
        sticker.animation = animation;
        animation.onfinish = () => { if (sticker.animation === animation) sticker.animation = null; };
      });
    });
    const stickerObserver = new IntersectionObserver(entries => {
      inView = entries[0].isIntersecting;
      lastY = window.scrollY;
      syncStickers();
    }, {rootMargin:'0px 0px -25px 0px'});
    stickerObserver.observe(stickerScene);
    cleanups.push(() => { stickerObserver.disconnect(); stopStickerMotion(); });
    listen(reducedMotion,'change', syncStickers);
    listen(document, 'visibilitychange', syncStickers);
    listen(window, 'resize', stopStickerMotion, {passive:true});
    listen(window, 'pagehide', stopStickerMotion);
    listen(window, 'pageshow', syncStickers);
    syncStickers();
  }


  const party = root.querySelector('.party-favours');
  if (party?.querySelector('.party-ribbon__float') && 'IntersectionObserver' in window) {
    const ribbons = [...party.querySelectorAll('.party-ribbon__float')];
    let partyVisible = false, partyFrame = 0;
    let partyTop = 0, partyHeight = 1, partyViewport = innerHeight;
    const compactParty = matchMedia('(max-width: 759px)');
    const canMoveParty = () => !signal.aborted && partyVisible && !document.hidden && !reducedMotion.matches;
    function stopParty() {
      cancelAnimationFrame(partyFrame);
      partyFrame = 0;
    }
    function paintParty() {
      partyFrame = 0;
      if (!canMoveParty()) return;
      const progress = Math.max(0, Math.min(1, (scrollY + partyViewport - partyTop) / (partyHeight + partyViewport)));
      const travel = (progress - .35) * (compactParty.matches ? 22 : 64);
      ribbons.forEach((ribbon, index) => {
        const direction = index ? -1 : 1;
        ribbon.style.transform = `translate3d(0,${(-travel * (index ? .7 : 1)).toFixed(2)}px,0) rotate(${(travel * direction * .15).toFixed(2)}deg)`;
      });
    }
    function scheduleParty() {
      if (canMoveParty() && !partyFrame) partyFrame = requestAnimationFrame(paintParty);
    }
    function measureParty() {
      if (!partyVisible) return;
      const rect = party.getBoundingClientRect();
      partyTop = rect.top + scrollY;
      partyHeight = rect.height;
      partyViewport = innerHeight;
      scheduleParty();
    }
    function syncParty() {
      if (!canMoveParty()) stopParty();
      if (reducedMotion.matches) ribbons.forEach(ribbon => ribbon.style.removeProperty('transform'));
      else measureParty();
    }
    const partyObserver = new IntersectionObserver(([entry]) => {
      partyVisible = entry.isIntersecting;
      if (partyVisible) party.classList.add('party-entered');
      syncParty();
    });
    partyObserver.observe(party);
    cleanups.push(() => { partyObserver.disconnect(); stopParty(); });
    listen(window, 'scroll', scheduleParty, {passive:true});
    listen(window, 'resize', measureParty, {passive:true});
    listen(document, 'visibilitychange', syncParty);
    listen(reducedMotion, 'change', syncParty);
    listen(window, 'pagehide', stopParty);
    listen(window, 'pageshow', syncParty);
  }
  const faq = root.querySelector('.sweet-faq');
  if (faq) {

    const jar = faq.querySelector('.faq-jar');
    if (jar && 'IntersectionObserver' in window) {
      const jarStickers = [...jar.querySelectorAll('.faq-jar__sticker')];
      jarStickers.forEach(sticker => listen(sticker.firstElementChild, 'animationend', event => {
        if (event.animationName === 'faq-sticker-pop') sticker.classList.add('has-arrived');
      }));
      if (!reducedMotion.matches) {
        jar.classList.add('stickers-ready');
        const revealStickers = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-sticker-visible');
            revealStickers.unobserve(entry.target);
          });
        }, {threshold:.15,rootMargin:'0px 0px -48px 0px'});
        jarStickers.forEach(sticker => revealStickers.observe(sticker));
        listen(reducedMotion, 'change', () => {
          if (!reducedMotion.matches) return;
          jar.classList.remove('stickers-ready');
          revealStickers.disconnect();
        });
        cleanups.push(() => revealStickers.disconnect());
      }
      const groundJar = () => {
        const heading = faq.querySelector('.sweet-faq__heading');
        const top = innerWidth < 760 ? heading.offsetTop + heading.offsetHeight + 20 : 40;
        jar.style.setProperty('--faq-scene-top', `${top}px`);
      };
      groundJar();
      listen(window, 'resize', groundJar, {passive:true});
      if ('ResizeObserver' in window) {
        const groundObserver = new ResizeObserver(groundJar);
        groundObserver.observe(faq);
        cleanups.push(() => groundObserver.disconnect());
      }
      let jarVisible = false, jarFrame = 0;
      const paintJar = () => {
        jarFrame = 0;
        if (!jarVisible || document.hidden || reducedMotion.matches) return;
        const top = jar.getBoundingClientRect().top;
        const progress = Math.max(0, Math.min(1, (innerHeight * .78 - top) / (innerHeight * .55)));
        jar.style.setProperty('--jar-open', progress.toFixed(3));
      };
      const scheduleJar = () => {
        if (jarVisible && !document.hidden && !reducedMotion.matches && !jarFrame) jarFrame = requestAnimationFrame(paintJar);
      };
      const stopJar = () => { if (jarFrame) cancelAnimationFrame(jarFrame); jarFrame = 0; };
      const syncJar = () => {
        stopJar();
        if (reducedMotion.matches) jar.style.removeProperty('--jar-open');
        else scheduleJar();
      };
      const jarObserver = new IntersectionObserver(([entry]) => {
        jarVisible = entry.isIntersecting;
        if (jarVisible) scheduleJar(); else stopJar();
      }, {rootMargin:'80px 0px'});
      jarObserver.observe(jar);
      listen(window, 'scroll', scheduleJar, {passive:true});
      listen(window, 'resize', scheduleJar, {passive:true});
      listen(document, 'visibilitychange', syncJar);
      listen(reducedMotion, 'change', syncJar);
      listen(window, 'pagehide', stopJar);
      listen(window, 'pageshow', syncJar);
      cleanups.push(() => { stopJar(); jarObserver.disconnect(); });
    }
    const items = [...faq.querySelectorAll('details')];


    items.forEach(item => {
      listen(item.querySelector('summary'),'click', event => {
        event.preventDefault();
        const opening = !item.open;
        const rows = [...items, faq.querySelector('.sweet-faq__footer'), ...root.querySelectorAll('.sweet-footer')];
        const before = rows.map(row => row.getBoundingClientRect().top);
        rows.forEach(row => row.getAnimations({subtree:true}).forEach(animation => animation.cancel()));
        items.forEach(other => { other.open = other === item && opening; });
        if (reducedMotion.matches) return;
        const after = rows.map(row => row.getBoundingClientRect().top);
        rows.forEach((row, index) => {
          const distance = before[index] - after[index];
          if (Math.abs(distance) > 1) row.animate([
            {transform:`translateY(${distance}px)`}, {transform:'translateY(0)'}
          ], {duration:opening ? 360 : 240,easing:'cubic-bezier(.16,.75,.25,1)'});
        });
        if (opening) item.querySelector('.sweet-faq__answer').animate([
          {opacity:0,transform:'translateY(6px)'}, {opacity:1,transform:'translateY(0)'}
        ], {duration:260,easing:'cubic-bezier(0,0,.2,1)'});
      });
    });
    if ('IntersectionObserver' in window && !reducedMotion.matches) {
      faq.classList.add('faq-motion');
      const reveal = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        faq.classList.add('is-visible');
        reveal.disconnect();
      }, {threshold:0,rootMargin:'0px 0px -30px 0px'});
      reveal.observe(faq);
      cleanups.push(() => reveal.disconnect());
    }
    listen(reducedMotion,'change', () => {
      if (reducedMotion.matches) {
        faq.classList.remove('faq-motion');
        faq.getAnimations({subtree:true}).forEach(animation => animation.cancel());
      }
    });
  }
  const motionAllowed = hero.dataset.motionEnabled !== 'false';

  const cloudStop = .48;
  let frame = 0, progress = 0, lastTime = 0, inView = true;
  const marqueesInView = new Set();
  const marqueeEpoch = performance.now();
  let geometry = {top: 0, height: 1, compact: innerWidth <= 700};
  hero.dataset.renderer = 'layered-image';
  function paintClouds(value, still = false) {
    const compact = geometry.compact;
    const movements = compact
      ? [{x:-12,rise:205,start:.76,end:1,rotate:-2}, {x:16,rise:250,start:.86,end:1,rotate:2}, {x:-12,rise:260,start:.88,end:1,rotate:-1}]
      : [{x:-20,rise:150,start:.78,end:1,rotate:-2}, {x:24,rise:195,start:.88,end:1,rotate:2}, {x:-24,rise:170,start:.92,end:1,rotate:-1}];
    clouds.forEach((cloud,index) => {
      const movement=movements[index];
      if(!movement) return;

      const t=still?0:Math.max(0,Math.min(cloudStop,value));
      const eased=1-(1-t)*(1-t);
      const y=still?0:28-eased*movement.rise;
      cloud.style.transform=`translate3d(${(movement.x*eased).toFixed(2)}px,${y.toFixed(2)}px,0) rotate(${(movement.rotate*eased).toFixed(2)}deg)`;
      cloud.style.opacity=String(still?movement.start:movement.start+(movement.end-movement.start)*eased);
    });
    hero.dataset.cloudProgress=(still?0:Math.max(0,Math.min(cloudStop,value))).toFixed(3);
  }

  function canAnimate() {
    return !signal.aborted && motionAllowed && !reducedMotion.matches && !document.hidden && inView && !dialog.open && menu.hidden;
  }
  function syncMarquee() {
    const allowed = !signal.aborted && motionAllowed && !reducedMotion.matches && !document.hidden && !dialog.open && menu.hidden;
    const elapsed = performance.now() - marqueeEpoch;
    marquees.forEach(marquee => {
      const running = allowed && marqueesInView.has(marquee);
      const wasRunning = marquee.classList.contains('is-running');
      marquee.classList.toggle('is-running', running);
      if (running && !wasRunning) {
        const track = marquee.querySelector('.sweet-marquee__track');
        const travel = track.getAnimations?.().find(animation => animation.animationName === 'sweet-marquee-travel');
        if (travel) travel.currentTime = elapsed;
      }
    });
  }
  function cloudTarget() {
    return Math.max(0,Math.min(cloudStop,(scrollY-geometry.top)/(geometry.height*(geometry.compact?.42:.65))));
  }
  function tick(now) {
    frame = 0;
    if (!canAnimate()) return;
    const target = cloudTarget();
    const dt = lastTime ? Math.min(50,now-lastTime) : 16.7;
    progress += (target-progress)*(1-Math.exp(-dt/(geometry.compact?95:125)));
    if (Math.abs(target-progress)<.0005) progress=target;
    paintClouds(progress);
    hero.dataset.motionState=progress===target?'settled':'scrolling';
    lastTime=now;
    if (progress!==target) frame=requestAnimationFrame(tick);
    else lastTime=0;
  }
  function schedule() {
    if (frame || !canAnimate()) return;
    if (progress === cloudTarget()) {
      hero.dataset.motionState='settled';
      return;
    }
    frame=requestAnimationFrame(tick);
  }
  function syncMotion() {
    syncMarquee();
    if(frame) cancelAnimationFrame(frame);
    frame=0;lastTime=0;
    if(reducedMotion.matches || !motionAllowed){
      progress=0;paintClouds(0,true);hero.dataset.motionState='static';
    } else if(!canAnimate()) hero.dataset.motionState='paused';
    else {
      paintClouds(progress);
      schedule();
    }
  }
  function measure() {
    const bounds=hero.getBoundingClientRect();
    geometry={top:bounds.top+scrollY,height:bounds.height,compact:innerWidth<=700};
    paintClouds(progress,reducedMotion.matches || !motionAllowed);
    syncMotion();
  }
  listen(window,'scroll',schedule,{passive:true});
  listen(window,'resize',measure,{passive:true});
  listen(reducedMotion,'change',syncMotion);
  listen(document,'visibilitychange',syncMotion);
  listen(window,'pagehide',()=>{if(frame)cancelAnimationFrame(frame);frame=0;marquees.forEach(marquee=>marquee.classList.remove('is-running'));});
  listen(window,'pageshow',measure);
  const visibility=new IntersectionObserver(([entry])=>{inView=entry.isIntersecting;syncMotion();});
  visibility.observe(hero);
  if (marquees.length) {
    const marqueeVisibility = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) marqueesInView.add(entry.target);
        else marqueesInView.delete(entry.target);
      });
      syncMarquee();
    });
    marquees.forEach(marquee => marqueeVisibility.observe(marquee));
    cleanups.push(() => marqueeVisibility.disconnect());
  }
  measure();

  instances.set(root, () => {
    controller.abort();
    cleanups.forEach(cleanup => cleanup());
    if (frame) cancelAnimationFrame(frame);
    visibility.disconnect();
    root.getAnimations({subtree:true}).forEach(animation => animation.cancel());
    marquees.forEach(marquee => marquee.classList.remove('is-running'));
    if (dialog.open) dialog.close();
    body.classList.remove('dialog-open', 'se-menu-open');
    menuBackground.forEach((previous, node) => { node.inert = previous; });
    menuBackground.clear();
    instances.delete(root);
  });
 }
 document.querySelectorAll('[data-conveyor-root]').forEach(initConveyor);
 document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-conveyor-root]').forEach(initConveyor));
 document.addEventListener('shopify:section:unload', event => {
   for (const [root,dispose] of instances) if (event.target.contains(root)) dispose();
 });
})();
